import { render, staticRenderFns } from "./BillableItemDeleteDialog.vue?vue&type=template&id=2ecd2187&scoped=true"
import script from "./BillableItemDeleteDialog.vue?vue&type=script&lang=js"
export * from "./BillableItemDeleteDialog.vue?vue&type=script&lang=js"
import style0 from "./BillableItemDeleteDialog.vue?vue&type=style&index=0&id=2ecd2187&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecd2187",
  null
  
)

export default component.exports